<i18n src="./translations"></i18n>

<template>
  <section v-if="relatedPairedArticles" class="pdp-related-paired-articles">
    <a
      :href="relatedPairedArticles.link"
      class="related-link"
      data-testid="pdp-related-paired-article-link"
      data-ssel-click="related_article"
      :data-ssel-label="relatedPairedArticles.label"
      data-ssel-position="0"
      :data-ssel-context="relatedArticleTrackingContext"
    >
      <div class="content">
        <h3 class="title">{{ $t('pdp-related-paired-articles.title') }}</h3>
        <p class="text">
          {{ $t('pdp-related-paired-articles.label') }}:
          <span class="article-number">{{ relatedPairedArticles.label }}</span>
        </p>
      </div>
      <Icon
        name="paired_articles_arrow_right"
        width="24"
        height="24"
        class="arrow"
        aria-hidden="true"
      />
    </a>
  </section>
</template>

<script>
import Icon from 'Components/00-generated/Icon.vue';
import {
  getAttributeCatalogSearchUrl,
  hasDisplayValue,
  normalizeAttributeValue,
  PAIRED_ARTICLE_NUMBERS_ID,
} from 'Libs/helpers/attribute-catalog-search';

export default {
  name: 'PdpRelatedPairedArticles',
  components: {
    Icon,
  },
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    relatedPairedArticles() {
      if (!this.product || !Array.isArray(this.product.attributes)) {
        return null;
      }

      const pairedAttribute = this.product.attributes.find(
        (attribute) =>
          attribute.id === PAIRED_ARTICLE_NUMBERS_ID &&
          hasDisplayValue(attribute.value)
      );

      if (!pairedAttribute) {
        return null;
      }

      const articleNumber = normalizeAttributeValue(pairedAttribute.value);
      const link = getAttributeCatalogSearchUrl({
        attributeId: pairedAttribute.id,
        articleNumber,
      });

      if (!link) {
        return null;
      }

      return {
        label: articleNumber,
        link,
      };
    },
    relatedArticleTrackingContext() {
      if (!this.relatedPairedArticles) {
        return undefined;
      }

      return JSON.stringify({
        relationship_type: PAIRED_ARTICLE_NUMBERS_ID,
        target_article_number: this.relatedPairedArticles.label,
        resolution: 'resolved',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pdp-related-paired-articles {
  margin-top: var(--space-2);

  .related-link {
    display: flex;
    width: 100%;
    padding: var(--space-2) var(--space-3);
    border-radius: var(--space-1);
    background-color: var(--color-white);
    border: 1px solid var(--color-rebranding-frenchGray);
    justify-content: space-between;
    align-items: center;
    gap: var(--space-1);
    font-size: var(--font-size-SM);
    color: var(--color-charcoal-gray);
    text-decoration: none;
  }

  .content {
    min-width: 0;
  }

  .title {
    margin: 0 0 var(--space-0--half);
    font-size: var(--font-size-M);
    font-weight: 700;
    color: var(--color-blackout);
  }

  .text {
    margin: 0;
    line-height: 18px;
  }

  .arrow {
    flex-shrink: 0;
  }
}
</style>
